<div class="loading-container" *ngIf="isLoading">
    <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>
    <p *ngIf="isLoading">We are navigating, please wait...</p>
</div>